/**
 * Connector factory: given route slug or connector type, returns the right
 * component/entry. Mirrors engines/index.js pattern (getEngine, getEngineStrategies).
 */
import { getComponentByRouteSlug } from './registry';

export { getConnectorDashboardEntry, getTeamConnectorConfig } from './registry';

/**
 * Get the team page container for a route slug (:connectorComponent).
 * Single factory entry point for "which container for this connector route?"
 * @param {string} routeSlug - e.g. 'jira'
 * @returns {React.Component | null}
 */
export function getTeamPageContainer(routeSlug) {
  return getComponentByRouteSlug(routeSlug);
}
